import { cn } from "@/lib/utils/helpers"
import { resolveTransferStaffUserId } from "../utils/transferPropertyCompanyWizard"
import type { StaffUserEditLinkProps } from "../types"

/**
 * Angular add/verify tables: `userEdit` + `.a_underline` on **name** only (role is plain text).
 * Opens user edit in a dialog (same as Angular `userEdit` → modal), not a new tab / route.
 */
export function StaffUserEditLink({
  userId,
  staff,
  className,
  children,
  testId,
  onOpenEdit,
}: StaffUserEditLinkProps) {
  const resolved =
    userId != null && !Number.isNaN(Number(userId)) && Number(userId) > 0
      ? Number(userId)
      : staff
        ? resolveTransferStaffUserId(staff)
        : undefined
  if (resolved == null) {
    return (
      <span className={className} data-testid={testId}>
        {children}
      </span>
    )
  }
  return (
    <button
      type="button"
      onClick={() => onOpenEdit(resolved)}
      className={cn(
        "inline border-0 bg-transparent p-0 text-left font-inherit",
        "cursor-pointer text-[rgb(21_151_255)] underline underline-offset-2 hover:text-[#0d7acc]",
        className,
      )}
      data-testid={testId}
    >
      {children}
    </button>
  )
}
